class OurTeamInfoModel{
	title;
	subtitle;

	constructor({ title = '', subtitle = '' }) {
		this.title = title;
		this.subtitle = subtitle;
	}
}

export default OurTeamInfoModel;
